import React from "react";
import { useSelector } from "react-redux";
import TitleItem from "../../../../viewer/chart/TitleItem.tsx";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch.ts";
import { selectChartSettingsState } from "../../../../../store/selectors/fieldsStateSelectors.ts";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks.ts";

export default function Title({ readonlyMode }: { readonlyMode: boolean }) {
  const settings = useSelector(selectChartSettingsState);
  const title = React.useMemo(() => settings.legend?.title || "", [settings]);
  const dispatch = useAppDispatch();

  return (
    <TitleItem
      title={title}
      placeholder="Set Legend Title..."
      disabled={readonlyMode}
      onUpdate={(title) => dispatch(fieldsStateActions.updateLegendSettings({ title }))}
    />
  );
}
